<template>
  <div :style="`height: ${height}px; min-width: 100%;`">
    <v-chart class="chart" :options="options" />
  </div>
</template>

<script>
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/pie';

export default {
  name: 'ApacheChart',
  props: {
    graphData: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number,
      default: 300,
    },
    colors: {
      type: Array,
      default: () => ['#2D61C2','#5E8DE4','#92B8FF','#113882'],
    },
    radius: {
      type: Array,
      default: () => ['30%', '60%'],
    },
    animation: {
      type: Boolean,
      default: true,
    },
    labelDistance: {
      type: Number,
      default: 20,
    },
  },
  components: {
    'v-chart': ECharts,
  },
  data() {
    return {
      options: {
        color: this.colors,
        series: [
          {
            type: 'pie',
            radius: this.radius,
            center: ['50%', '50%'],
            label: {
              show: true,
              position: 'outside',
              overflow: 'break',
              align: 'center',
              formatter: '{b}\n{d}%',
              textStyle: {
                color: '#000000',
                align: 'center',
              },
            },
            labelLine: {
              show: false,
              length: this.labelDistance,
            },
            data: this.graphData,
            animation: this.animation,
          },
        ],
      },
    };
  },
};
</script>

<style>
  .echarts {
    width: 100%;
    height: 100%;
  }
</style>
